// components/subscription/CategoryExplorer.jsx
import { ArrowLeft2 } from "iconsax-react";
import React from "react";
import { useTranslation } from "react-i18next";

const CategoryExplorer = ({ path, categories, onSelect, onPathClick }) => {
  const { t, i18n } = useTranslation();
  const isRtl = i18n.language.includes('fa');

  // تغییر جهت آیکون بر اساس زبان
  const ArrowIcon = () => (
    <ArrowLeft2 size={16} className={`inline mx-1 ${isRtl ? '' : 'transform rotate-180'}`} />
  );

  return (
    <div className="mb-6">
      {/* Breadcrumb مسیر */}
      <nav className={`text-gray-600 mb-4 ${isRtl ? 'text-right' : 'text-left'}`}>
        <span
          onClick={() => onPathClick(-1)}
          className="text-indigo-600 cursor-pointer hover:underline"
        >
          {t('all')}
        </span>
        {path?.length > 0 && (
          <>
            <ArrowIcon />
            {path.map((item, i) => (
              <span
                key={i}
                onClick={() => onPathClick(i)}
                className="text-indigo-600 cursor-pointer hover:underline"
              >
                {item}
                {i < path.length - 1 && <ArrowIcon />}
              </span>
            ))}
          </>
        )}
      </nav>

      {/* لیست دسته‌بندی‌ها */}
      <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4">
        {categories.map((cat) => (
          <div
            key={cat._id}
            onClick={() => onSelect(cat)}
            className="bg-white border rounded-xl shadow-sm hover:shadow-md cursor-pointer text-center py-4 px-2 transition"
          >
            <h3 className="text-gray-800 font-semibold">{cat.title}</h3>
            {cat.description && (
              <p className="text-sm text-gray-500 mt-1">{cat.description}</p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CategoryExplorer;